import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatErr } from "../lib/apiClient";
import { Wrench, Lock } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setMsg("");
    if (pw.length < 6) return setErr("Password must be at least 6 characters.");
    if (pw !== pw2) return setErr("Passwords don't match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setMsg("Password set! Redirecting to login...");
      setTimeout(() => nav("/login"), 1500);
    } catch (e) { setErr(formatErr(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-md bg-[#0F4C81] flex items-center justify-center"><Wrench className="text-white" size={22} strokeWidth={2} /></div>
          <div className="font-display font-bold text-xl">PlumbOps</div>
        </div>
        <h2 className="font-display text-3xl font-bold tracking-tight">Set new password</h2>
        <p className="text-sm text-slate-500 mt-1">Choose a new password for your account.</p>
        {!token && <div className="mt-6 p-3 bg-red-50 border border-red-200 rounded text-sm text-red-800">Missing reset token. Use the link from your invitation email.</div>}
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div><label className="text-xs uppercase font-medium text-slate-700 tracking-wider">New password</label>
            <input data-testid="reset-pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required className="mt-1 w-full px-3 py-2.5 border border-slate-300 rounded-md text-sm focus:outline-none focus:border-[#0F4C81]" />
          </div>
          <div><label className="text-xs uppercase font-medium text-slate-700 tracking-wider">Confirm password</label>
            <input data-testid="reset-pw2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required className="mt-1 w-full px-3 py-2.5 border border-slate-300 rounded-md text-sm focus:outline-none focus:border-[#0F4C81]" />
          </div>
          {err && <div className="text-sm text-red-600 bg-red-50 px-3 py-2 rounded">{err}</div>}
          {msg && <div className="text-sm text-emerald-700 bg-emerald-50 px-3 py-2 rounded">{msg}</div>}
          <button type="submit" disabled={loading || !token} data-testid="reset-submit" className="w-full bg-[#0F4C81] hover:bg-[#0A365C] text-white py-2.5 rounded-md text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-60"><Lock size={14} /> {loading ? "Setting..." : "Set Password"}</button>
        </form>
        <div className="mt-6 text-center"><Link to="/login" className="text-sm text-[#0F4C81] hover:underline">Back to login</Link></div>
      </div>
    </div>
  );
}
